/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import MassActionsAction from './MassActionsAction/index'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import ToggleAllAction from './ToggleAllAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/NoteTemplates/Templates/Content/Content",
  tableData
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<MassActionsAction
  viewPath={`${viewPath}/MassActionsAction`}
/>
<ToggleAllAction
  viewPath={`${viewPath}/ToggleAllAction`}
/>
</div>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={tableData}
 width="100%"
 overflow="auto"
/>
</div>
{children}
</React.Fragment>)
}